import Util from "../../../../utils/Util";


class AiChatMessage {
    constructor(id = 0, message = "", isMine = false) {
        this.id = id;
        this.groupId = "";
        this.createTime = Util.getCurrentTime();
        this.message = message;
        this.isMine = isMine;
        this.isCompleted = false;
        this.mindServerId;
        this.mindId = -1;
    }

    equal(data) {
        if (data == null) {
            return false;
        }
        var result = false;
        result = result || data.id != this.id;
        result = result || data.groupId != this.groupId;
        result = result || data.createTime != this.createTime;
        result = result || data.message != this.message;
        result = result || data.isMine != this.isMine;
        result = result || data.mindServerId != this.mindServerId;
        result = result || data.mindId != this.mindId;
        result = result || data.isCompleted != this.isCompleted;
        return !result;
    }

    copy() {
        let copy = new AiChatMessage(this.id, this.message, this.isMine);
        copy.groupId = this.groupId;
        copy.createTime = this.createTime;
        copy.setCompleted(this.isCompleted);
        copy.setMindId(this.mindId);
        copy.setMindServerId(this.mindServerId);
        return copy;
    }

    setId(id) {
        this.id = id;
    }

    setMessage(message) {
        this.message = message;
    }

    setGroupId(groupId) {
        this.groupId = groupId;
    }

    setMindServerId(mindServerId) {
        this.mindServerId = mindServerId;
    }

    setMindId(mindId) {
        this.mindId = mindId;
    }

    setCompleted(completed) {
        this.isCompleted = completed;
    }

    setCreateTime(createTime) {
        this.createTime = createTime;
    }

    isCompleted() {
        return isCompleted;
    }
}
export default AiChatMessage